{
  "expo": {
    "name": "ATLAS",
    "slug": "qarasay-kassa",
    "owner": "atlas-business",
    "version": "7.1.3",
    "newArchEnabled": false,
    "runtimeVersion": "5.0",
    "orientation": "default",
    "scheme": "atlas",
    "userInterfaceStyle": "automatic",
    "icon": "./assets/icon.png",
    "splash": {
      "image": "./assets/splash.png",
      "resizeMode": "contain",
      "backgroundColor": "#F6F6F6"
    },
    "updates": {
      "fallbackToCacheTimeout": 5000,
      "url": "https://u.expo.dev/c8a61326-b027-4e88-af2c-425f55de20f4"
    },
    "assetBundlePatterns": [
      "**/*"
    ],
    "ios": {
      "supportsTablet": true,
      "bundleIdentifier": "kz.qarasay.kassa",
      "infoPlist": {
        "NSCameraUsageDescription": "This app uses the camera to take photos of invoices and save them to cloud storage",
        "NSPhotoLibraryUsageDescription": "Users can upload photos of invoices to cloud storage",
        "CFBundleLocalizations": [
          "en",
          "ru"
        ],
        "UIDesignRequiresCompatibility": true
      },
      "googleServicesFile": "./GoogleService-Info.plist",
      "config": {
        "usesNonExemptEncryption": false
      },
      "jsEngine": "hermes",
      "buildNumber": "209"
    },
    "android": {
      "adaptiveIcon": {
        "foregroundImage": "./assets/adaptive-icon.png",
        "backgroundColor": "#000000"
      },
      "package": "kz.qarasay.kassa",
      "permissions": [
        "android.permission.CAMERA",
        "android.permission.INTERNET"
      ],
      "blockedPermissions": [
        "android.permission.WRITE_EXTERNAL_STORAGE",
        "android.permission.READ_EXTERNAL_STORAGE",
        "android.permission.READ_MEDIA_IMAGES",
        "android.permission.READ_MEDIA_VIDEO",
        "android.permission.ACCESS_MEDIA_LOCATION",
        "android.permission.ACCESS_COARSE_LOCATION",
        "android.permission.ACCESS_FINE_LOCATION",
        "android.permission.RECORD_AUDIO"
      ],
      "intentFilters": [
        {
          "action": "VIEW",
          "data": [
            {
              "mimeType": "text/csv"
            },
            {
              "mimeType": "image/*"
            }
          ],
          "category": [
            "BROWSABLE",
            "DEFAULT"
          ]
        }
      ],
      "googleServicesFile": "./google-services.json",
      "jsEngine": "hermes",
      "versionCode": 213
    },
    "web": {
      "favicon": "./assets/favicon.png",
      "bundler": "metro",
      "build": {
        "babel": {
          "include": [
            "@ui-kitten/components"
          ]
        }
      }
    },
    "plugins": [
      "@react-native-firebase/app",
      [
        "./configPlugins/withCustomGradleProperties"
      ],
      [
        "./configPlugins/withCustomManifest"
      ],
      [
        "expo-build-properties",
        {
          "ios": {
            "useFrameworks": "static",
            "deploymentTarget": "15.1"
          },
          "android": {
            "minSdkVersion": 24,
            "compileSdkVersion": 35,
            "targetSdkVersion": 35
          }
        }
      ],
      [
        "expo-image-picker",
        {
          "photosPermission": "This app uses the camera to take photos of invoices and save them to cloud storage",
          "cameraPermission": "This app uses the camera to take photos of invoices and save them to cloud storage"
        }
      ],
      [
        "expo-updates",
        {
          "username": "beks.m"
        }
      ],
      "expo-localization",
      [
        "expo-document-picker",
        {
          "iCloudContainerEnvironment": "Production"
        }
      ],
      "expo-notifications"
    ],
    "extra": {
      "eas": {
        "projectId": "c8a61326-b027-4e88-af2c-425f55de20f4"
      }
    }
  }
}
